<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <header-list
                    :title="pageTitle"
                    :placeholderSearch="searchPlaceholder"
                    v-model="query"
                    :routeAddName="`${moduleId}.${pageID}.create`"
                    :routeAddParams="{ type: 'resource' }"
                    :canAdd="canAdd"
                    :addTitle="addLayer"
                    :icon="icon"
                    @search="onSearch">
                    <template v-slot:buttons-right v-if="canAdd">
                        <router-link
                            class="btn btn-main btn-rounded btn-sm min-w-auto my-0 px-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline"
                            :to="{ name: `${moduleId}.${pageID}.create`,
                            params: { type: 'group' } }">
                            <i v-if="icon != ''" :class="icon"></i>&nbsp;<span>{{ $t(addGroup) }}</span>
                        </router-link>
                    </template>
                </header-list>

                <div class="row">
                    <div class="col">
                        <recursive-list
                            :list="list"
                            :checkActions="checkActions"
                            :moduleId="moduleId"
                            :routeGroupEdit="`${moduleId}.${pageID}.show.group`"
                            :routeItemEdit="`${moduleId}.${pageID}.show.item`"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :onRemove="onRemove"
                            :deleteItem="deleteItem"
                            :table="table"
                            :showError="showError"
                            :pageCode="pageID"
                            :targetField="'layers'"
                        >
                        </recursive-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralMixin from './mixins/GeneralMixin'

export default {
    name: 'LayersList',
    mixins: [
        GeneralMixin
    ],
    components: {
        RecursiveList: () => import(/* webpackChunkName: "layers-recursive-list" */ './RecursiveList'),
    },
    data() {
        let pageID = 'layers';
        return {
            pageID: pageID,
            table: {
                showPagination: false,
                tableInline: true,
                columns: [
                    // {
                    //     label: 'Imagem',
                    //     field:  'icon',
                    //     sortable: false,
                    // },
                    {
                        label: this.$t(`${pageID}.list.name`),
                        field:  'name',
                        class: 'text-truncate',
                        sortable: false,
                    },
                    {
                        label: '',
                        field:  null,
                        sortable: false,
                        class: 'actions',
                    }
                ],
            },
        }
    },
    computed: {
        addGroup() {
            // return `<i class="fas fa-plus"></i>&nbsp;${this.$t(`${this.pageID}.buttons.add_group`)}`
            return this.$t(`${this.pageID}.buttons.add_group`);
        },
        addLayer() {
            return this.$t(`${this.pageID}.buttons.add_layer`);
        },
        icon() {
            return 'fas fa-plus'
        }
    },
    methods: {
        onRemove: function(id, index){
            this.loadData();
        },
    }
}
</script>

<style>

</style>